(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["hollow-product-option-help"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('hollow-option-help')) {
    const hollowOptionHelpState = new Map();
    customElements.define('hollow-option-help', class extends HTMLElement {
      connectedCallback() {
        this.details = this.querySelector('details');
        this.stateKey = this.dataset.helpKey;
        this.details.open = hollowOptionHelpState.get(this.stateKey) === true;
        this.rememberState = () => hollowOptionHelpState.set(this.stateKey, this.details.open);
        this.details.addEventListener('toggle', this.rememberState);
      }
      disconnectedCallback() {
        this.details?.removeEventListener('toggle', this.rememberState);
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["hollow-product-styles"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('hollow-product-styles')) {
    const warmedStyleImages = new Map();
    const warmedStylePages = new Set();
    customElements.define('hollow-product-styles', class extends HTMLElement {
      connectedCallback() {
        this.events?.abort();
        this.events = new AbortController();
        const previewTheme = new URLSearchParams(window.location.search).get('preview_theme_id');
        const connection = navigator.connection;
        this.querySelectorAll('a[href]').forEach(link => {
          if (previewTheme) {
            const destination = new URL(link.href, window.location.href);
            destination.searchParams.set('preview_theme_id', previewTheme);
            link.href = destination.pathname + destination.search + destination.hash;
          }
          if (connection?.saveData || ['slow-2g', '2g'].includes(connection?.effectiveType)) return;
          const warm = () => {
            if (link.dataset.previewImage && !warmedStyleImages.has(link.dataset.previewImage)) {
              const image = new Image();
              image.decoding = 'async';
              image.src = link.dataset.previewImage;
              warmedStyleImages.set(link.dataset.previewImage, image);
            }
            if (!warmedStylePages.has(link.href)) {
              const hint = document.createElement('link');
              hint.rel = 'prefetch';
              hint.as = 'document';
              hint.href = link.href;
              document.head.append(hint);
              warmedStylePages.add(link.href);
            }
          };
          ['pointerenter', 'focus', 'touchstart'].forEach(event => link.addEventListener(event, warm, { once: true, passive: true, signal: this.events.signal }));
        });
      }
      disconnectedCallback() {
        this.events?.abort();
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
